import { FirmwareModel } from '../shared/types';
import { baseApi } from './base';

const functionUrl = process.env.REACT_APP_FUNCTION_HOST_URL;

export const firmwareApi = {
    getFirmwares: async (query?: string): Promise<FirmwareModel[]> => {
        return baseApi.get(`${functionUrl}/api/v1/firmware`);
    },
    downloadFirmware: async (path: string) => {
        try {
            await baseApi.get(`${functionUrl}${path}`);
        } catch (error) {
            console.log({ error });
        }
    },
    createFirmware: async (formData: any, firmware: FirmwareModel) => {
        const { name, componentId, appVersion, version, protocolVersion, configuration, status, description } = firmware;

        const queryParams = `name=${name}&componentId=${componentId}&appVersion=${appVersion}&version=${version}&protocolVersion=${protocolVersion}&configuration=${configuration}&status=${status}&description=${description}`;
        
        await baseApi.post(`${functionUrl}/api/v1/firmware?${queryParams}`, formData);
    },
    updateFirmware: async (body: FirmwareModel) => {
        await baseApi.put(`${functionUrl}/api/v1/firmware/${body.id}`, body);
    },
    deleteFirmware: async (id: string) => {
        await baseApi.delete(`${functionUrl}/api/v1/firmware/${id}`);
    }
};
